// search functionality for bankers archive


import bankerSearchWithFilter from "./bankersearch/bankersearch-filter";
import bankerSearchNoFilter from "./bankersearch/bankersearch-nofilter";



Number.isInteger =
  Number.isInteger ||
  function (value) {
    return (
      typeof value === "number" &&
      isFinite(value) &&
      Math.floor(value) === value
    );
  };

const createModal = (
  bankerName,
  bankerTitle,
  bankerPhone,
  bankerImg,
  bankerEmail
) => {
  const modalTemplateEl = document.getElementById("bankermodaltemplate");
  const modalEl = document.createElement("div");

  const cleanModalTemplateHTML = modalTemplateEl.innerHTML
    .replaceAll("<!--", "")
    .replaceAll("-->", "");
  modalEl.innerHTML = cleanModalTemplateHTML;
  modalEl.id = "banker-modal";
  modalEl.className = "banker-modal-el";
  modalEl.setAttribute("hidden", true);

  if (modalEl.querySelector("#salesforce-form")) {
    modalEl.querySelector(
      "#salesforce-form"
    ).id = `salesforce-form-${Math.random().toString(16).slice(2)}`;
  }

  modalEl.innerHTML = modalEl.innerHTML.replace("{{NAME}}", bankerName);
  modalEl.innerHTML = modalEl.innerHTML.replace("{{TITLE}}", bankerTitle);
  modalEl.innerHTML = modalEl.innerHTML.replace("{{PHONE}}", bankerPhone);
  if (modalEl.querySelector("#CampaignName__c")) {
    modalEl.querySelector("#CampaignName__c").value = bankerEmail;
  }

  const modalImg = modalEl.querySelectorAll("img[src]");

  for (let i = 0; i < modalImg.length; i += 1) {
    const modalImgSrc = modalImg[i];
    modalImgSrc.setAttribute("src", bankerImg);
  }

  return modalEl;
};

// depends if search is enabled
const filterContainerEl = document.querySelector(
  "[data-js=bankersearchfilter]"
);
if (filterContainerEl) {
  bankerSearchWithFilter(createModal);
} else {
  bankerSearchNoFilter(createModal);
}
